import { jsx as _jsx } from "react/jsx-runtime";
import RelationGroupMultiSelect from '../multiselect/RelationGroupMultiSelect';
export const FilterRelationGroupMultiSelect = ({ item, setFilter, activeFilters, label, isAlwaysVisible, enabled, }) => {
    var _a;
    return ({
        filterItem: item,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        enabled: enabled,
        element: (_jsx(RelationGroupMultiSelect, { selection: (_a = activeFilters[item]) !== null && _a !== void 0 ? _a : [], onChange: value => setFilter({ [item]: value !== null && value !== void 0 ? value : undefined }), placeholder: label })),
    });
};
